import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

const LABEL = { "-1": "Vence amanhã", "0": "Vence hoje", "1": "Venceu ontem", "7": "Venceu há 7 dias" };
const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);

const Num = ({ v, label, cls }) => (
  <div className="text-center">
    <div className={`text-lg font-bold ${cls}`}>{v}</div>
    <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
  </div>
);

export const WaGroupsCard = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const load = () => api.get("/dispatch/wa-groups").then((r) => setRows(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  const tot = rows.reduce((a, r) => ({ e: a.e + r.enviados, d: a.d + r.entregues, l: a.l + r.lidos, f: a.f + r.falhas }), { e: 0, d: 0, l: 0, f: 0 });

  return (
    <div data-testid="wa-groups-card" className="rounded-2xl border border-[#1F293D] bg-[#111827] p-4">
      <div className="mb-3 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-500/15"><MessageCircle className="h-5 w-5 text-emerald-400" /></span>
        <div>
          <div className="text-sm font-bold text-white">WhatsApp de hoje por grupo</div>
          <div data-testid="wa-groups-total" className="text-[11px] text-slate-500">
            {tot.e} enviados · {tot.d} entregues ({pct(tot.d, tot.e)}%) · {tot.l} lidos ({pct(tot.l, tot.e)}%) · {tot.f} falhas
          </div>
        </div>
      </div>
      {!rows.length && <div className="text-xs text-slate-500">Nenhum WhatsApp enviado hoje.</div>}
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.rule_id} data-testid={`wa-group-${r.offset_days ?? "manual"}`} className="rounded-xl border border-[#1F293D] bg-[#0B1019] px-3 py-2">
            <div className="grid grid-cols-4 items-center gap-2 sm:grid-cols-[1fr_repeat(4,56px)]">
              <div className="col-span-4 min-w-0 truncate text-xs font-semibold text-slate-200 sm:col-span-1">{LABEL[String(r.offset_days)] || r.name}
                {r.sms_fallback > 0 && <span data-testid={`wa-group-sms-${r.offset_days ?? "manual"}`} className="ml-2 font-normal text-amber-300/90">{r.sms_fallback} SMS de reforço</span>}</div>
              <Num v={r.enviados} label="enviados" cls="text-slate-200" />
              <Num v={r.entregues} label="entregues" cls="text-emerald-300" />
              <Num v={r.lidos} label="lidos" cls="text-sky-300" />
              <Num v={r.falhas} label="falhas" cls={r.falhas ? "text-red-300" : "text-slate-600"} />
            </div>
            {r.motivos?.length > 0 && (
              <div data-testid={`wa-group-reasons-${r.offset_days ?? "manual"}`} className="mt-2 flex flex-wrap gap-1.5 border-t border-[#1F293D] pt-2">
                {r.motivos.map((m) => (
                  <span key={m.motivo} className="rounded-md border border-red-500/25 bg-red-500/[0.07] px-2 py-0.5 text-[11px] text-red-200">
                    <b>{m.n}×</b> {m.motivo}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
